<template>
	<div class="body">
		<div class="body-container" v-if="data">
			
			<div class="title-ctr">{{data.title}}</div>
			
			<div class="step-ctr">
				<div class="step-name">{{data.step}}</div>
				
				<div class="step-route" @click="clickRule(data.ruleRoute)">{{data.ruleRoute.title}}</div>
			</div>
			
			<el-table :data="data.sourceList"  border stripe>
				<el-table-column label="年份" align="center" prop="year"/>
				
				<el-table-column label="企业数（个）" align="center" prop="company_num">
					<template v-slot="{ row }">
						<label class="edit-label" @click="clickChangeData(row.year, 'company', row.company_num)">{{row.company_num}}</label>
					</template>
				</el-table-column>
				<el-table-column label="营业收入（亿元）" align="center" prop="company_income">
					<template v-slot="{ row }">
						<label class="edit-label" @click="clickChangeData(row.year, 'income', row.company_income)">{{row.company_income}}</label>
					</template>
				</el-table-column>
				<el-table-column label="平均用工人数（人）" align="center" prop="employee_num">
					<template v-slot="{ row }">
						<label class="edit-label" @click="clickChangeData(row.year, 'employee', row.employee_num)">{{row.employee_num}}</label>
					</template>
				</el-table-column>
			</el-table>
			
			<div class="source-note">注：表数据来源于统计年鉴，<label style="color: red;">如有错误，可点击修正</label>。{{data.sourceNote}}</div>
			
			<el-table :data="data.curList" border stripe>
				<el-table-column label="年份" align="center" prop="year"/>
				<el-table-column label="企业数（个）" align="center" prop="company_num"/>
				<el-table-column label="营业收入（亿元）" align="center" prop="company_income"/>
				<el-table-column label="平均用工人数（人）" align="center" prop="employee_num"/>
			</el-table>
			
			<div class="new-note">{{data.newNote}}</div>
			<div class="error-tips" v-if="data.errorTips">{{data.errorTips}}</div>
		</div>

		<div class="action-ctr" v-if="data">
		
			<el-button v-if="data.errorTips" type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn" disabled>下一步</el-button>
			<el-button v-else type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>
		
		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog"
			align="center">
			
			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>
		
	
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :title="dataTitle" :visible.sync="showDataDialog" append-to-body v-if="showDataDialog"
			align="center">
			
			<div class="data-ctr">
				<el-input v-model="dataValue" placeholder="请输入数值" class="data-input" />
			</div>
		
			
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickConfirmData()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getMatchDataSourcePage,
		changeMatchData
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				data: null,
				showIntroDialog: false,
				showDataDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				},
				dataTitle: '',
				dataValue: '',
				year: '',
				type: '',
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},
			
			buildParams(){
				this.params['year'] = this.year;
				this.params['type'] = this.type;
				this.params['value'] = this.dataValue;
				return this.params;
			},

			requestData() {
				getMatchDataSourcePage(this.buildParams()).then(res => {
					let realData = res.data;
					this.data = realData;
				});
			},

			clickNext() {
				let path = '/trend?id=' + this.params['id'];
				this.$router.push(path);
			},

			clickRule(route){
				if (route.type == this.variableType.File){
					let path = route.path;
					window.open(path, '_blank')
				}else if(route.type == this.variableType.Rich){
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},
			
			clickCloseIntroDialog(){
				this.showIntroDialog = false;
			},
			
			clickChangeData(year, type, value){
				let title = year;
				if(type == 'company'){
					title += '企业数';
				}else if(type == 'income'){
					title += '营业收入';
				}else{
					title += '平均用工人数';
				}
				
				title += '修改';
				
				this.year = year;
				this.type = type;
				this.dataTitle = title;
				this.dataValue = value;
				this.showDataDialog = true;
			},
			
			clickConfirmData(){
				changeMatchData(this.buildParams()).then(res => {
					this.requestData();
					this.showDataDialog = false;
				})
			}
			
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "data_source.scss";
</style>